export const CANVAS_MEDIA_SAVE_FAILURE_MESSAGE = 'Failed to save to board';

const SAVED_CUTS_IMPORT_FAILED_MESSAGE = 'Saved the trimmed clips. The other files could not be saved.';
const SAVED_IMPORT_CUTS_FAILED_MESSAGE = 'Saved the other files. The trimmed clips could not be saved.';

export type GetCanvasMediaSaveFailureMessageParams = {
  cutsRequested: boolean;
  cutsSaved: boolean;
  importRequested: boolean;
  imported: boolean;
};

/** Undefined means every requested part saved. A string is the toast to show instead of success. */
export const getCanvasMediaSaveFailureMessage = ({
  cutsRequested,
  cutsSaved,
  importRequested,
  imported,
}: GetCanvasMediaSaveFailureMessageParams): string | undefined => {
  const importFailed = importRequested && !imported;
  const cutsFailed = cutsRequested && !cutsSaved;

  if (importFailed && cutsRequested && cutsSaved) {
    return SAVED_CUTS_IMPORT_FAILED_MESSAGE;
  }

  if (cutsFailed && importRequested && imported) {
    return SAVED_IMPORT_CUTS_FAILED_MESSAGE;
  }

  if (importFailed || cutsFailed) {
    return CANVAS_MEDIA_SAVE_FAILURE_MESSAGE;
  }

  return undefined;
};
